import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number | undefined, lang: 'en' | 'ru' = 'en', decimals: number = 2): string {
    if (bytes === undefined || bytes === 0) { return '0 B'; }

    const k = 1024;
    const units = UNITS[lang] || UNITS.en;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));

    return `${size} ${units[i]}`;
  }
}

const UNITS = {
  en: ['B', 'KB', 'MB', 'GB', 'TB'],
  ru: ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']
}
